import React from "react";
import { Reveal } from "./_shared";
import { scrollToId } from "../../hooks/useLenis";
import { logAnalytics } from "../../lib/api";
import { EVENT_CONFIG } from "../../config/event";

const points = [
    "Dimostrazione della piattaforma",
    "Utilizzo del chatbot e dell'agente AI",
    "Consultazione intelligente di informazioni, documenti e scadenze",
    "Digitalizzazione dei registri aziendali",
    "Gestione dei dossier (compreso il Dossier ASL)",
    "Eliminazione dei registri cartacei",
    "Esempi concreti di utilizzo in azienda",
    "Domande e confronto con il team",
];

export default function Event() {
    return (
        <section id="evento" className="relative py-28 md:py-40 bg-navy-950 text-white overflow-hidden">
            <div aria-hidden className="absolute inset-0 bg-grid-navy opacity-70 pointer-events-none" />
            <div aria-hidden className="absolute -top-40 right-0 w-[600px] h-[600px] bg-gold-400/20 blur-3xl rounded-full animate-blob" />
            <div aria-hidden className="absolute bottom-0 -left-40 w-[500px] h-[500px] bg-navy-700/40 blur-3xl rounded-full" />

            <div className="relative max-w-[1400px] mx-auto px-5 md:px-8">
                <div className="grid lg:grid-cols-[1.15fr_1fr] gap-16 items-center">
                    <div>
                        <Reveal>
                            <div className="chapter-chip mb-6">
                                <span className="num">07</span>
                                <span className="text-white/50">Presentazione ufficiale</span>
                            </div>
                        </Reveal>
                        <Reveal delay={0.1}>
                            <div className="flex flex-wrap gap-2 items-center">
                                <div className="inline-flex items-center gap-2 rounded-full bg-gold-400 text-navy-950 px-3 py-1.5 text-[11px] font-bold tracking-widest uppercase">
                                    Presentazione ufficiale
                                </div>
                                <div className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/10 text-white/80 px-3 py-1.5 text-[11px] font-bold tracking-widest uppercase">
                                    Posti limitati
                                </div>
                            </div>
                        </Reveal>
                        <Reveal delay={0.2}>
                            <h2 className="font-display font-black text-white text-[44px] sm:text-[62px] lg:text-[80px] leading-[0.98] tracking-tight mt-6">
                                Scopri <br />
                                <span className="italic font-serif text-gold-400">SafetyDesk81</span>
                                <br />dal vivo.
                            </h2>
                        </Reveal>
                        <Reveal delay={0.3}>
                            <div className="mt-8 text-white/75 text-lg leading-relaxed max-w-xl">
                                <p>
                                    <strong className="text-white">{EVENT_CONFIG.EVENT_DAY_LABEL}</strong> presenteremo ufficialmente SafetyDesk81
                                    alle aziende, agli imprenditori e ai responsabili interni.
                                </p>
                                <p className="mt-4">
                                    Durante l'evento mostreremo dal vivo il <strong className="text-white">chatbot e l'agente AI</strong>, i
                                    <strong className="text-white"> registri completamente digitalizzati</strong>, la gestione di scadenze, formazione, visite mediche e sopralluoghi.
                                </p>
                                <p className="mt-4 text-gold-300 font-semibold">
                                    Intelligenza artificiale, gestione delle scadenze e registri completamente digitali — tutto insieme.
                                </p>
                            </div>
                        </Reveal>

                        <Reveal delay={0.4}>
                            <div className="mt-10">
                                <button
                                    data-testid="event-cta-register"
                                    onClick={() => { logAnalytics("cta_click", { source: "event" }); scrollToId("iscriviti"); }}
                                    className="group inline-flex items-center gap-3 bg-gold-400 hover:bg-gold-300 text-navy-950 font-bold text-base px-8 py-4 rounded-full shadow-glow-gold transition-all duration-300 hover:-translate-y-1"
                                >
                                    Prenota il tuo posto
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" className="transition-transform group-hover:translate-x-1">
                                        <path d="M5 12h14M13 5l7 7-7 7" />
                                    </svg>
                                </button>
                            </div>
                        </Reveal>
                    </div>

                    {/* Right: event card */}
                    <Reveal delay={0.15}>
                        <div className="relative rounded-3xl bg-white text-navy-950 p-8 md:p-10 shadow-card overflow-hidden">
                            <div aria-hidden className="absolute -top-16 -right-16 w-56 h-56 bg-gold-200 rounded-full blur-3xl" />
                            <div className="relative">
                                <div className="text-[11px] font-mono tracking-widest text-navy-400 uppercase">Save the date</div>
                                <div className="mt-1 font-display font-black text-[54px] leading-none tracking-tight">
                                    01<span className="text-gold-500">.10.</span><span className="text-navy-400">'26</span>
                                </div>
                                <div className="mt-2 text-navy-700 font-semibold text-sm">Giovedì 1 ottobre 2026</div>
                                <div className="mt-6 pt-6 border-t border-navy-100 space-y-3">
                                    <div className="flex items-start gap-3">
                                        <div className="w-8 h-8 rounded-lg bg-navy-950 text-gold-400 flex items-center justify-center flex-shrink-0">
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s7-7 7-13a7 7 0 0 0-14 0c0 6 7 13 7 13z" /><circle cx="12" cy="9" r="2.5" /></svg>
                                        </div>
                                        <div>
                                            <div className="text-sm font-bold text-navy-950">{EVENT_CONFIG.EVENT_LOCATION}</div>
                                            <div className="text-xs text-navy-500">{EVENT_CONFIG.EVENT_ADDRESS}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-6 pt-6 border-t border-navy-100">
                                    <div className="text-[10px] font-mono uppercase tracking-widest text-navy-400 mb-3">Programma della serata</div>
                                    <ul className="space-y-2.5">
                                        <TimelineItem time={EVENT_CONFIG.EVENT_APERITIVO_TIME} label="Aperitivo di benvenuto" />
                                        <TimelineItem time={EVENT_CONFIG.EVENT_PRESENTATION_TIME} label="Presentazione ufficiale di SafetyDesk81" highlight />
                                        <TimelineItem time={EVENT_CONFIG.EVENT_DINNER_TIME} label="Cena a buffet" />
                                    </ul>
                                </div>

                                <div className="mt-6 pt-6 border-t border-navy-100">
                                    <div className="text-[10px] font-mono uppercase tracking-widest text-navy-400 mb-2">Cosa vedrai</div>
                                    <ul className="space-y-1.5 text-[13px] text-navy-700">
                                        {points.map((p) => (
                                            <li key={p} className="flex items-start gap-2">
                                                <span className="w-4 h-4 mt-0.5 rounded-full bg-gold-400 text-navy-950 flex items-center justify-center flex-shrink-0">
                                                    <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round"><polyline points="20 6 9 17 4 12" /></svg>
                                                </span>
                                                {p}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}

function TimelineItem({ time, label, highlight }) {
    return (
        <li className={`flex items-center gap-3 rounded-xl p-2.5 ${highlight ? "bg-gold-100" : "bg-navy-50"}`}>
            <div className={`font-mono font-bold text-sm w-14 ${highlight ? "text-gold-700" : "text-navy-700"}`}>{time}</div>
            <div className={`text-sm ${highlight ? "text-navy-950 font-semibold" : "text-navy-800"}`}>{label}</div>
        </li>
    );
}
